module.exports = __webpack_public_path__ + "static/media/henrik.dd71e3a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/members/henrik.jpg
// module id = 50
// module chunks = 0